import React from 'react';
import { Box, Tabs, Tab } from '@mui/material';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';

import { PageShell } from 'components/AppShell';
import { USE_NEW_SHELL } from 'core/flags';
import LegacyYandexTrackerLayout from './YandexTrackerLayout.legacy';

const TAB_PATHS = {
  tasks: '/yandex/tracker/tasks',
  queues: '/yandex/tracker/queues',
} as const;

function YandexTrackerLayoutNew(): React.ReactElement {
  const navigate = useNavigate();
  const location = useLocation();

  const currentTab = location.pathname.startsWith(TAB_PATHS.queues) ? 'queues' : 'tasks';

  const handleTabChange = (_: React.SyntheticEvent, value: 'tasks' | 'queues') => {
    navigate(TAB_PATHS[value]);
  };

  return (
    <PageShell
      title="Яндекс Трекер"
      subtitle="Задачи и очереди, подключённые к проекту"
      toolbar={
        <Tabs
          value={currentTab}
          onChange={handleTabChange}
          sx={{
            minHeight: 36,
            '& .MuiTab-root': {
              minHeight: 36,
              py: 0.5,
              textTransform: 'none',
              fontSize: 13,
            },
          }}
        >
          <Tab label="Задачи" value="tasks" />
          <Tab label="Очереди" value="queues" />
        </Tabs>
      }
      bodyScrolls={false}
      noContentPadding
    >
      <Box
        sx={{
          flex: 1,
          minHeight: 0,
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
          p: 2,
        }}
      >
        <Outlet />
      </Box>
    </PageShell>
  );
}

function YandexTrackerLayout(): React.ReactElement {
  if (!USE_NEW_SHELL) {
    return <LegacyYandexTrackerLayout />;
  }
  return <YandexTrackerLayoutNew />;
}

export default YandexTrackerLayout;
